/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_ColorInputs */

const en_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert speaker color`)
};

const fr_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer la couleur de l'intervenant`)
};

const de_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecherfarbe einfügen`)
};

const it_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il colore dell'altoparlante`)
};

const ru_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте цвет динамика`)
};

const es_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar color del altavoz`)
};

const zh_cn2_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入扬声器颜色`)
};

const ja_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーの色を挿入`)
};

const hi_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर का रंग डालें`)
};

const pt_pt2_insert_speaker_color = /** @type {(inputs: Insert_Speaker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir cor do alto-falante`)
};

/**
* | output |
* | --- |
* | "Insert speaker color" |
*
* @param {Insert_Speaker_ColorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_color = /** @type {((inputs?: Insert_Speaker_ColorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_ColorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_color(inputs)
	if (locale === "de") return de_insert_speaker_color(inputs)
	if (locale === "it") return it_insert_speaker_color(inputs)
	if (locale === "ru") return ru_insert_speaker_color(inputs)
	if (locale === "es") return es_insert_speaker_color(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_color(inputs)
	if (locale === "ja") return ja_insert_speaker_color(inputs)
	if (locale === "hi") return hi_insert_speaker_color(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_color(inputs)
	return en_insert_speaker_color(inputs)
});